var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"success":"","disabled":!_vm.canStart},on:{"click":_vm.submit}},[_vm._v(" Start campaign ")])
}
var staticRenderFns = []

export { render, staticRenderFns }